import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { QuantityCounterComponent } from '@libs/form/components';
import { IconComponent } from '@libs/components/icons';
import { QuantityCounterInputModel } from '@libs/form/models';
import { ProductBundleItemModel, ProductListItemBaseModel, ProductModel } from '@libs/shop/models';
import { ProductPriceVisibilityDirective } from '@libs/shared/ui';
import { ProductCardCoreComponent } from '../product-card-core';
import { ProductPriceFormatterComponent } from '../product-prices/product-price-formatter';

@Component({
  selector: 'ui-product-bundle-list-card',
  imports: [
    QuantityCounterComponent,
    ReactiveFormsModule,
    ProductPriceFormatterComponent,
    IconComponent,
    ProductCardCoreComponent,
    ProductPriceVisibilityDirective,
  ],
  templateUrl: './product-bundle-list-card.component.html',
  styleUrl: './product-bundle-list-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBundleListCardComponent {
  public product: InputSignal<ProductModel> = input.required();
  public productItem: InputSignal<ProductListItemBaseModel> = input.required();
  public quantityCounterConfig: InputSignal<QuantityCounterInputModel> = input.required();
  public quantityCounterControl: InputSignal<FormControl<number>> = input.required();
  public showCheckbox: InputSignal<boolean> = input(false);
  public selected: ModelSignal<boolean> = model(false);
  public isQuantityChangeLoading: InputSignal<boolean> = input(false);
  public isRemoveLoading: InputSignal<boolean> = input(false);
  public readonly: InputSignal<boolean> = input(false);
  public enableProductClickTracking: InputSignal<boolean> = input(true);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  public isSapBundle: Signal<boolean> = computed(() => (['reimbursement', 'advantage']).includes(this.product().bundleType!));

  public removed: OutputEmitterRef<ProductListItemBaseModel> = output();

  public bundledProducts: Signal<ProductBundleItemModel[]> = computed(() => this.product().bundle?.products ?? []);
}
